/**
 * Demo-Modus-Erkennung (qa-only F-01).
 * Das Backend liefert settings.demo_mode je nach Quelle als boolean oder String
 * ("true"/"false") — hier dieselbe tolerante Semantik wie in advisor-gate.js.
 */
export function isDemoMode(settings) {
  const v = settings?.demo_mode;
  return v === true || v === 'true';
}